
<div id="qnaReport" class="qna-report-download">
    <div *ngIf="configRowData">
        <h4>Configuration</h4>
        <ag-grid-angular class="ag-theme-alpine"
                         [rowData]="configRowData"
                         [columnDefs]="configColumnDefs"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>

    <div *ngIf="qnaReportDownloadViewModel" class="py-2">
        <h4>Available Reports</h4>
        <ag-grid-angular class="ag-theme-alpine"
                         [rowData]="reportRowData"
                         [columnDefs]="reportColumnDefs"
                         (gridReady)="onGridReady1($event)">
        </ag-grid-angular>
    </div>
</div>